<template>
  <div class="sidebar">
    <div class="basic">
      <div class="header clearfix">
        <span class="title">基本资料</span>
        <!-- <a class="more" href="#" @click.prevent>查看全部 &gt;</a> -->
      </div>
      <ul class="content">
        <li>
          <span class="title">登录名</span>
          <span class="value ellipsis">{{member.loginName || '-'}}</span>
        </li>
        <li>
          <span class="title">姓名</span>
          <span class="value ellipsis">{{member.name || '-'}}</span>
        </li>
        <li>
          <span class="title">手机号</span>
          <span class="value ellipsis">{{member.mobile | hideStr}}</span>
        </li>
        <li>
          <span class="title">邮箱</span>
          <span class="value ellipsis">{{member.email | hideStr(2)}}</span>
        </li>
      </ul>
    </div>
    <div class="company" v-if="!_.isEmpty(member.enterprise)">
      <div class="header clearfix">
        <span class="title">企业资料</span>
        <a class="more" href="#" @click.prevent="showMoreCompany = true">查看全部 &gt;</a>
      </div>
      <ul class="content">
        <li>
          <span class="title">企业名称</span>
          <span class="value ellipsis">{{member.enterprise.name || '-'}}</span>
        </li>
        <li>
          <span class="title">联系人</span>
          <span class="value ellipsis">{{member.enterprise.contacts || '-'}}</span>
        </li>
        <li>
          <span class="title">联系方式</span>
          <span class="value ellipsis">{{member.enterprise.tel | hideStr}}</span>
        </li>
        <li>
          <span class="title">企业地址</span>
          <span class="value ellipsis">{{member.enterprise.address || '-'}}</span>
        </li>
      </ul>
    </div>
    <Modal v-model="showMoreCompany" class="accountModalBox" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content" v-if="member && member.enterprise">
        <div class="company-info">
          <div class="header">企业信息</div>
          <div class="company-content">
            <div class="form_item">
              <div class="title">企业名称：</div>
              <div class="value">{{member.enterprise.name || '-'}}</div>
            </div>
            <div class="form_item">
              <div class="title">联系人：</div>
              <div class="value">{{member.enterprise.contacts || '-'}}</div>
            </div>
            <div class="form_item">
              <div class="title">联系方式：</div>
              <div class="value">{{member.enterprise.tel | hideStr}}</div>
            </div>
            <div class="form_item">
              <div class="title">企业地址</div>
              <div class="value">{{member.enterprise.address || '-'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'MyAccountUserInfoZH',
  props: {
    userInfo: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      showMoreCompany: false
    }
  },
  computed: {
    member () {
      return this.userInfo.member || {}
    }
  }
}
</script>
<style scoped>
  .sidebar{
    width: 240px;
  }
  .sidebar .basic{
    margin-bottom: 35px;
  }
  .sidebar .header{
    border-bottom: 1px solid #ECECEC;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .sidebar .header .title{
    color: #1F8AFD;
    display: block;
    float: left;
    padding-bottom: 10px;
    border-bottom: 1px solid #1F8AFD;
  }
  .sidebar .header .more{
    color: #999;
    float: right;
    padding-bottom: 10px;
    font-size: 12px;
  }
  .sidebar .content li{
    margin-bottom: 20px;
    position: relative;
    padding-left: 45px;
    font-size: 13px;
    color: #333;
  }
  .sidebar .content li .title{
    display: block;
    width: 60px;
    position: absolute;
    top:0;
    left:0;
  }
  .sidebar .content li .value{
    text-align: right;
    display: block;
  }
  .form_item{
    position: relative;
    padding-left: 78px;
    margin-bottom: 20px;
  }
  .form_item .title{
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    color: #333;
    font-size: 14px;
  }
  .form_item .value{
    color:#999;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/UserInfo.vue